import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {AnalyticsVisualizationBarChartType as BarChartType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BarChartConfigEditorProps} from 'insights/analytics-visualizations/configs/BarChartConfigEditor';
import {PANE_MARGIN} from 'insights/InsightsConstants';
import staticURL from 'lib/staticURL';
import Tooltip from 'ui-library/bs/Tooltip';
import {BLUE_LIGHT, BLUE_POWDER, GRAY_LIGHT, GRAY_LIGHTER} from 'ui-library/Colors';

const BAR_CHART_TYPE_TO_IMG_LINK: {[key in BarChartType]: string} = {
  [BarChartType.STACKED]: '/static/img/insights/stacked_bar_chart.svg',
  [BarChartType.STANDARD]: '/static/img/insights/grouped_bar_chart.svg',
};

const BAR_CHART_TYPE_TO_USER_FACING_NAME: {[key in BarChartType]: string} = {
  [BarChartType.STACKED]: 'Stacked bar chart',
  [BarChartType.STANDARD]: 'Grouped bar chart',
};

export const ORDERED_BAR_CHART_TYPES = [BarChartType.STANDARD, BarChartType.STACKED];

export type BarChartTypeConfigEditorComponentProps = Pick<
  BarChartConfigEditorProps,
  'onUpdateParameters' | 'parameters'
>;

export default function BarChartTypeConfigEditorComponent({
  onUpdateParameters,
  parameters,
}: BarChartTypeConfigEditorComponentProps): JSX.Element {
  return (
    <div
      className={css(barChartTypeConfigEditorStyles.typeOptionsWrapper)}
      {...getTestProps({component: 'BarChartTypeConfigEditor', element: 'root'})}
    >
      {ORDERED_BAR_CHART_TYPES.map((barChartType) => (
        <Tooltip key={barChartType} title={BAR_CHART_TYPE_TO_USER_FACING_NAME[barChartType]}>
          <img
            alt={BAR_CHART_TYPE_TO_USER_FACING_NAME[barChartType]}
            className={css(
              barChartTypeConfigEditorStyles.typeOption,
              parameters.barChartType === barChartType && barChartTypeConfigEditorStyles.activeTypeOption
            )}
            onClick={() => {
              onUpdateParameters({
                barChartType,
              });
            }}
            src={staticURL(BAR_CHART_TYPE_TO_IMG_LINK[barChartType])}
          />
        </Tooltip>
      ))}
    </div>
  );
}

export const barChartTypeConfigEditorStyles = StyleSheet.create({
  typeOptionsWrapper: {
    marginBottom: PANE_MARGIN,
    marginLeft: PANE_MARGIN,
  },
  typeOption: {
    background: GRAY_LIGHTER,
    borderColor: GRAY_LIGHT,
    borderStyle: 'solid',
    borderRadius: 4,
    borderWidth: 1,
    cursor: 'pointer',
    marginRight: 6,
    width: 32,
    height: 32,
  },
  activeTypeOption: {
    background: BLUE_POWDER,
    borderColor: BLUE_LIGHT,
  },
});
